import * as React from 'react';
import { useSelector } from 'react-redux';

import { LinkToFullVersion } from '../../components/LinkToFullVersion';
import { selectEventCategory } from '../../selectors/eventCategory';
import { IApplicationState } from '../../types/redux';
import { trackSiteTypeChange } from './tracking';

export const LinkToFullVersionContainer: React.FC = () => {
  const showSiteTypeChanging = useSelector((state: IApplicationState) => state.showSiteTypeChanging);
  const eventCategory = useSelector(selectEventCategory);

  const handleSiteTypeChange = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();

    trackSiteTypeChange(eventCategory);

    document.cookie = 'flavour=desktop;path=/;domain=.cian.ru';
    location.reload();
  };

  if (!showSiteTypeChanging) {
    return null;
  }

  return <LinkToFullVersion onClick={handleSiteTypeChange} />;
};
